/** No-op replacement for `next/cache` revalidation in SPA builds. */
export function revalidatePath(_path: string, _type?: "layout" | "page"): void {}

export function revalidateTag(_tag: string): void {}
